const FREE_SHIP = window.deporres?.freeShip || 4900;
const SHIP_COST = 490;

const toggle = document.querySelector(".nav__toggle");
const cartCount = document.querySelectorAll("[data-cart-count]");
const drawer = document.querySelector("[data-drawer]");
const cartList = document.querySelector("[data-cart-list]");
const cartEmpty = document.querySelector("[data-cart-empty]");
const cartTotal = document.querySelector("[data-cart-total]");
const checkout = document.querySelector("[data-checkout]");
const cartUpsell = document.querySelector("[data-cart-upsell]");
const cartFoot = document.querySelector(".drawer__foot");
const cartShip = document.querySelector("[data-cart-ship]");
const cartShipText = document.querySelector("[data-cart-ship-text]");
const cartShipFill = document.querySelector("[data-cart-ship-fill]");
const discountForm = document.querySelector("[data-cart-discount]");
const discountInput = document.querySelector("[data-discount-input]");
const discountStatus = document.querySelector("[data-discount-status]");
const CODE_KEY = "deporres-code";
const toast = document.querySelector("[data-toast]");
const navEl = document.querySelector(".nav");
const navSearchForm = document.querySelector("[data-nav-search]");
const navSearchInput = document.querySelector("[data-nav-search-input]");
const navSearchBtn = document.querySelector("[data-open-search]");

function euro(cents) {
  const n = Number(cents) / 100;
  return `${n.toFixed(2).replace(".", ",")} €`;
}

function isDefaultVariantTitle(title) {
  const t = String(title || "").trim().toLowerCase();
  return t === "" || t === "default title" || t === "default";
}

function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.remove("is-on");
  void toast.offsetWidth;
  toast.classList.add("is-on");
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => toast.classList.remove("is-on"), 2200);
}

function storedCode() {
  try {
    return sessionStorage.getItem(CODE_KEY) || "";
  } catch {
    return "";
  }
}

function checkoutUrl(code = storedCode()) {
  const base = window.deporres?.routes?.checkout || "/checkout";
  return code ? `${base}?discount=${encodeURIComponent(code)}` : base;
}

function applyCode(code, { quiet } = {}) {
  const next = String(code || "").trim().toUpperCase();
  if (!next) return "";
  try {
    sessionStorage.setItem(CODE_KEY, next);
  } catch {}
  if (checkout) checkout.href = checkoutUrl(next);
  if (discountInput) discountInput.value = next;
  if (discountStatus) {
    discountStatus.hidden = false;
    discountStatus.textContent = `Code ${next} gilt an der Kasse`;
  }
  if (!quiet) showToast(`Code ${next} gilt an der Kasse`);
  return next;
}

function syncCheckout() {
  const code = storedCode();
  if (checkout) checkout.href = checkoutUrl(code);
  if (discountInput && code) discountInput.value = code;
  if (discountStatus && code) {
    discountStatus.hidden = false;
    discountStatus.textContent = `Code ${code} gilt an der Kasse`;
  }
}

function bumpCartCount() {
  cartCount.forEach((el) => {
    el.classList.remove("is-bump");
    void el.offsetWidth;
    el.classList.add("is-bump");
  });
}

async function fetchCart() {
  const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
  return res.json();
}

async function addToCart(variantId, qty) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 }),
  });
  if (!res.ok) {
    showToast("Konnte nicht in den Warenkorb.");
    return null;
  }
  const item = await res.json();
  bumpCartCount();
  showToast(`${item.title} hinzugefügt`);
  await renderCart();
  return item;
}

async function changeLine(key, qty) {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: key, quantity: qty }),
  });
  await renderCart();
}

async function upsellPicks(cart) {
  const remain = Math.max(0, FREE_SHIP - cart.items_subtotal_price);
  if (!remain || !cart.item_count) return [];
  const inCart = new Set(cart.items.map((item) => String(item.product_id)));
  try {
    const res = await fetch("/products.json?limit=50");
    const data = await res.json();
    return (data.products || [])
      .filter((product) => product.variants[0]?.available && !inCart.has(String(product.id)))
      .sort((a, b) => Math.abs(a.variants[0].price * 100 - remain) - Math.abs(b.variants[0].price * 100 - remain))
      .slice(0, 2);
  } catch {
    return [];
  }
}

async function renderCart() {
  const cart = await fetchCart();
  cartCount.forEach((el) => {
    el.textContent = String(cart.item_count);
  });
  if (!cartList) return;
  cartList.innerHTML = "";
  const total = cart.items_subtotal_price;
  const ship = total >= FREE_SHIP ? 0 : SHIP_COST;
  const remain = Math.max(0, FREE_SHIP - total);

  cart.items.forEach((item) => {
    const img = item.featured_image?.url || item.image || "";
    const li = document.createElement("li");
    li.dataset.key = item.key;
    li.innerHTML = `
      <img src="${img}" alt="" />
      <div>
        <p>${item.product_title}</p>
        <p>${!isDefaultVariantTitle(item.variant_title) ? `${item.variant_title} · ` : ""}${euro(item.final_price)}</p>
        <div class="qty qty--sm">
          <button type="button" data-qty-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-qty-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
        </div>
      </div>
      <button type="button" data-remove="${item.key}">Entfernen</button>
    `;
    cartList.appendChild(li);
  });

  const empty = cart.item_count === 0;
  if (cartEmpty) cartEmpty.hidden = !empty;
  if (cartTotal) cartTotal.hidden = empty;
  if (checkout) checkout.hidden = empty;
  if (discountForm) discountForm.hidden = empty;
  if (cartFoot) cartFoot.hidden = empty;
  if (cartShip) {
    cartShip.hidden = empty;
    if (!empty && cartShipFill && cartShipText) {
      const pct = Math.min(100, Math.round((total / FREE_SHIP) * 100));
      cartShipFill.style.width = `${pct}%`;
      cartShipText.textContent = remain > 0 ? `Noch ${euro(remain)} bis Versand frei` : "Versand frei";
    }
  }
  if (cartUpsell) {
    const picks = empty ? [] : await upsellPicks(cart);
    cartUpsell.hidden = picks.length === 0;
    if (picks.length) {
      cartUpsell.innerHTML = `
        <p>Dazu legen</p>
        ${picks
          .map((product) => {
            const variant = product.variants[0];
            const img = product.images[0]?.src || "";
            return `
          <div class="drawer__add">
            <img src="${img}" alt="" />
            <div>
              <p>${product.title}</p>
              <p>${!isDefaultVariantTitle(variant.title) ? variant.title + " · " : ""}${euro(Number(variant.price) * 100)}</p>
            </div>
            <button type="button" data-add data-variant-id="${variant.id}">Hinzufügen</button>
          </div>`;
          })
          .join("")}
      `;
    }
  }
  if (!empty && cartTotal) {
    cartTotal.innerHTML = `
      <span>Warenwert</span><span>${euro(total)}</span>
      <span>Versand</span><span>${ship === 0 ? "Kostenlos" : euro(ship)}</span>
      <strong>Gesamt</strong><strong>${euro(total + ship)}</strong>
    `;
  }
  if (empty && discountStatus) discountStatus.hidden = true;
  else syncCheckout();
}

function openCart() {
  if (!drawer) return;
  closeNavSearch();
  drawer.classList.add("is-open");
  document.body.classList.add("cart-open");
}

function closeCart() {
  drawer?.classList.remove("is-open");
  document.body.classList.remove("cart-open");
}

function closeNavSearch() {
  if (!navEl?.classList.contains("is-search")) return;
  navEl.classList.remove("is-search");
  navSearchBtn?.setAttribute("aria-expanded", "false");
  navSearchBtn?.setAttribute("aria-label", "Suchen");
  navSearchInput?.blur();
}

function openNavSearch() {
  document.body.classList.remove("nav-open");
  toggle?.setAttribute("aria-expanded", "false");
  navEl?.classList.add("is-search");
  navSearchBtn?.setAttribute("aria-expanded", "true");
  navSearchBtn?.setAttribute("aria-label", "Suche schließen");
  window.setTimeout(() => navSearchInput?.focus(), 220);
}

toggle?.addEventListener("click", () => {
  const open = document.body.classList.toggle("nav-open");
  toggle.setAttribute("aria-expanded", String(open));
  if (open) closeNavSearch();
});

document.querySelectorAll(".nav__links a").forEach((link) => {
  link.addEventListener("click", () => {
    document.body.classList.remove("nav-open");
    toggle?.setAttribute("aria-expanded", "false");
  });
});

navSearchBtn?.addEventListener("click", () => {
  if (navEl?.classList.contains("is-search")) closeNavSearch();
  else openNavSearch();
});

document.addEventListener("click", (event) => {
  if (!navEl?.classList.contains("is-search")) return;
  if (event.target.closest("[data-nav-search], [data-open-search]")) return;
  closeNavSearch();
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  if (navEl?.classList.contains("is-search")) closeNavSearch();
  if (drawer?.classList.contains("is-open")) closeCart();
});

document.querySelector("[data-open-cart]")?.addEventListener("click", openCart);
document.querySelector("[data-close-cart]")?.addEventListener("click", closeCart);
drawer?.addEventListener("click", (event) => {
  if (event.target === drawer) closeCart();
});

cartList?.addEventListener("click", (event) => {
  const qtyBtn = event.target.closest("[data-qty-key]");
  if (qtyBtn) {
    changeLine(qtyBtn.getAttribute("data-qty-key"), Number(qtyBtn.getAttribute("data-qty")));
    return;
  }
  const remove = event.target.closest("[data-remove]");
  if (remove) changeLine(remove.getAttribute("data-remove"), 0);
});

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-add]");
  if (!button) return;
  event.preventDefault();
  const id = button.getAttribute("data-variant-id");
  if (!id) return;
  const fromUpsell = Boolean(button.closest("[data-cart-upsell]"));
  const qtyInput = document.querySelector("[data-qty-input]");
  const qty = !fromUpsell && qtyInput ? Number(qtyInput.value || 1) : 1;
  await addToCart(id, qty);
  openCart();
});

document.querySelector("[data-product-form]")?.addEventListener("submit", async (event) => {
  event.preventDefault();
});

document.querySelector("[data-qty-down]")?.addEventListener("click", () => {
  const input = document.querySelector("[data-qty-input]");
  if (input) input.value = String(Math.max(1, Number(input.value) - 1));
});

document.querySelector("[data-qty-up]")?.addEventListener("click", () => {
  const input = document.querySelector("[data-qty-input]");
  if (input) input.value = String(Number(input.value) + 1);
});

document.querySelectorAll("[data-pdp-options] button").forEach((btn) => {
  btn.addEventListener("click", () => {
    if (btn.disabled) return;
    document.querySelectorAll("[data-pdp-options] button").forEach((item) => item.classList.toggle("is-on", item === btn));
    const id = btn.getAttribute("data-variant-id");
    const price = btn.getAttribute("data-price");
    const title = btn.getAttribute("data-title");
    const available = btn.getAttribute("data-available") === "true";
    const input = document.querySelector("[data-variant-input]");
    if (input) input.value = id;
    document.querySelectorAll("[data-pdp-add], [data-pdp-sticky-add]").forEach((el) => {
      el.setAttribute("data-variant-id", id);
      el.disabled = !available;
      el.textContent = available ? `In den Warenkorb · ${price}` : "Ausverkauft";
    });
    const sizeEl = document.querySelector("[data-pdp-size]");
    const priceEl = document.querySelector("[data-pdp-price]");
    const stickyPrice = document.querySelector("[data-pdp-sticky-price]");
    if (sizeEl) {
      const dummy = isDefaultVariantTitle(title);
      sizeEl.textContent = dummy ? "" : title;
      sizeEl.hidden = dummy;
    }
    if (priceEl) priceEl.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    const url = new URL(location.href);
    url.searchParams.set("variant", id);
    history.replaceState(null, "", url);
  });
});

document.querySelector("[data-pdp-thumbs]")?.addEventListener("click", (event) => {
  const btn = event.target.closest("button[data-src]");
  if (!btn) return;
  const img = document.querySelector("[data-pdp-image]");
  if (img) img.src = btn.getAttribute("data-src");
  document.querySelectorAll("[data-pdp-thumbs] button").forEach((item) => item.classList.toggle("is-on", item === btn));
});

const sticky = document.querySelector("[data-pdp-sticky]");
const buy = document.querySelector(".pdp .buy");
if (sticky && buy && "IntersectionObserver" in window) {
  const watch = new IntersectionObserver(([entry]) => {
    sticky.classList.toggle("is-on", !entry.isIntersecting);
  }, { threshold: 0 });
  watch.observe(buy);
}

document.querySelectorAll("[data-home-tab]").forEach((btn) => {
  btn.addEventListener("click", () => {
    const tab = btn.getAttribute("data-home-tab");
    document.querySelectorAll("[data-home-tab]").forEach((item) => item.classList.toggle("is-on", item === btn));
    document.querySelectorAll("[data-home-panel]").forEach((panel) => {
      panel.hidden = panel.getAttribute("data-home-panel") !== tab;
    });
    if (window.lucide) lucide.createIcons({ attrs: { "stroke-width": 1.6 } });
  });
});

const reviewsTrack = document.querySelector("[data-reviews]");
document.querySelector("[data-reviews-prev]")?.addEventListener("click", () => {
  reviewsTrack?.scrollBy({ left: -320, behavior: "smooth" });
});
document.querySelector("[data-reviews-next]")?.addEventListener("click", () => {
  reviewsTrack?.scrollBy({ left: 320, behavior: "smooth" });
});

document.querySelector("[data-close-rail]")?.addEventListener("click", () => {
  document.querySelector("[data-rail]")?.remove();
});

renderCart().catch(() => {});
document.addEventListener("DOMContentLoaded", () => {
  if (window.lucide) lucide.createIcons({ attrs: { "stroke-width": 1.6 } });
});
if (window.lucide) lucide.createIcons({ attrs: { "stroke-width": 1.6 } });

(function keepCookieStylesLast() {
  const link = document.querySelector('link[href*="cookie-banner"]');
  if (!link) return;
  const bump = () => {
    if (document.body && document.body.lastElementChild !== link) document.body.appendChild(link);
  };
  bump();
  const obs = new MutationObserver(bump);
  obs.observe(document.head, { childList: true });
  if (document.body) obs.observe(document.body, { childList: true });
  setTimeout(() => obs.disconnect(), 10000);
})();

discountForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  applyCode(discountInput?.value);
});
